module.exports = __webpack_public_path__ + "static/media/Illustrator.a78717bd.svg";